import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=3ce71a6c&"
import script from "./CreateClient.vue?vue&type=script&lang=js&"
export * from "./CreateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports